import Enumerator from '../global/Enumerator';

export const contactMedicareCardColors = ['none', 'green', 'blue', 'yellow'];

export class ContactMedicareCardColor extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'green';
        break;
      case '2':
        correctOption = 'blue';
        break;
      case '3':
        correctOption = 'yellow';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ContactMedicareCardColor.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  green: {
    get title() {
      return 'Green';
    }
  },
  blue: {
    get title() {
      return 'Blue';
    }
  },
  yellow: {
    get title() {
      return 'Yellow';
    }
  }
});

export default {
  contactMedicareCardColors,
  ContactMedicareCardColor
};
